import { createSelector } from 'reselect'
import flow from 'lodash/flow'
import curryRight from 'lodash/curryRight'
import filter from 'lodash/filter'
import sortBy from 'lodash/sortBy'
import map from 'lodash/map'
import { getCurrentUser } from '@/core/selectors/currentUser'
import { getMembers } from '@/core/selectors/members'
import { accountManager } from '../../selectors/company'

const getUsedTemplate = state => state.views.candidateDetails_LEGACY.interviewRequest.utils.usedTemplate

const curriedFilter = curryRight(filter)
const curriedMap = curryRight(map)

const sortBySlug = members => sortBy(members, 'slug')

const ownedByHiringTeam = hiringTeamId => element => {
  const hiringTeamIds = element.hiring_teams.map(hiring_team => hiring_team.id)

  return hiringTeamIds.includes(hiringTeamId)
}

const normaliseMember = member => ({
  mention: member.slug,
  label: member.name,
  accountManager: false,
})

const memberMentions = createSelector([getMembers, getCurrentUser, accountManager], (members, currentUser, accountManager) => {
  const memberMentions = flow(
    sortBySlug,
    curriedFilter(ownedByHiringTeam(currentUser.current_hiring_team_id)),
    curriedMap(normaliseMember),
  )(members)
  return accountManager && accountManager.mention ? [accountManager, ...memberMentions] : memberMentions
})

export const mentionList = createSelector([memberMentions], members =>
  members.map(member => ({
    accountManager: member.accountManager,
    avatar: null,
    name: member.label,
    handle: member.mention,
  })),
)

export const showTemplateToMember = createSelector(
  [getCurrentUser, getUsedTemplate],
  (currentUser, usedTemplate) => currentUser.show_ir_template && !usedTemplate,
)
